export default "__VITE_ASSET__DtI7Kh0t__"